module.exports = __webpack_public_path__ + "img/ic-tick-circle.014371e4.svg";